{
  "it": {
    "project": {
      "actions": {
        "activate": "Attiva",
        "addProjectMaintainer": "Aggiungi gestore di progetto",
        "add_as_partner": "Aggiungi come partner",
        "add_as_partner_description": "È sicuro di voler aggiungere {partner} come partner a questo progetto?",
        "add_project_partner": "Aggiungi partner del progetto",
        "additional_information": "Informazioni aggiuntive",
        "changeProjectLogin": "Modifica immagine del progetto",
        "changeProjectLogo": "Modifica logo del progetto",
        "deactivate": "Disattiva",
        "edit": "Modifica",
        "finishRequest": "Invia richiesta",
        "follow": "Segui",
        "giveAccess": "Concedi accesso",
        "maintainerAdd": "Aggiungi gestore di progetto",
        "maintainerAddDescription": "È sicuro di voler concedere a {maintainer} l'accesso a questo progetto?",
        "maintainerRemove": "Rimuovi gestore di progetto",
        "maintainerRemoveDescription": "È sicuro di voler revocare l'accesso a questo progetto per {maintainer}?",
        "new": "Progetto",
        "next": "Avanti",
        "remove_partner": "Rimuovi {partner}",
        "remove_project_partner": "Rimuovi partner del progetto",
        "remove_project_partner_description": "È sicuro di voler rimuovere {partner} dai partner del progetto?",
        "selectOption": "Selezioni un'opzione",
        "selectTemplate": "Selezioni un modello",
        "submit": "Crea progetto",
        "unFollow": "Smetti di seguire"
      },
      "attributes": {
        "address": "Indirizzo",
        "currency": "Valuta",
        "delivery_date_actual": "Data di fine prevista",
        "delivery_date_contractual": "Data di fine contrattuale",
        "description": "Descrizione",
        "internal_note": "Nota interna del progetto",
        "measurement": "Unità di misura",
        "name": "Nome",
        "picture_login_url": "Immagine del progetto",
        "picture_logo_url": "Logo del progetto",
        "quotity_total": "Quotità totale di trasferimento",
        "skip_building": "Nascondi edificio",
        "skip_lot": "Nascondi lotto",
        "skip_phase": "Nascondi fase",
        "skip_unit": "Nascondi unità (progetto a unità singola)",
        "start_date": "Data di inizio",
        "units_count": "Numero di unità create",
        "units_count_max": "Numero massimo di unità",
        "vat_percentage": "% IVA",
        "website_url": "URL del sito web"
      },
      "errors": {
        "capacity": {
          "cant_have_more_units": "Capacità massima raggiunta, ci contatti."
        }
      },
      "import": {
        "add": "+ Aggiungi",
        "add_instead": "Preferisco aggiungere {levels}",
        "building": "edificio",
        "buildings": "edifici",
        "changed_mind": "Salta questo livello",
        "create_new": "Qual è il nome di {type}",
        "download_template": "Scarica modello di importazione",
        "drop_or_upload": "Trascini il modello qui o faccia clic per caricarlo",
        "error_line": "Errore alla riga",
        "file_unreadable": "Impossibile leggere questo file. Verifica che sia un foglio di calcolo valido e riprova",
        "fill_space_info": "Compili il modello con le informazioni sulle pertinenze",
        "fill_unit_info": "Compili il modello con le informazioni sulle unità",
        "fix_file_upload": "Corregga i problemi e carichi nuovamente il file.</br>Le unità esistenti non verranno rimosse, ma saranno aggiornate se qualcosa è cambiato nel file per quell'unità dall'ultimo caricamento.",
        "fix_file_upload_space": "Corregga i problemi e carichi nuovamente il file.</br>Le pertinenze esistenti non verranno rimosse, ma saranno aggiornate se qualcosa è cambiato nel file per quella pertinenza dall'ultimo caricamento.",
        "for": "per",
        "import_column_title": "Vuole aggiungere {column_type}?",
        "import_partial_success": "Importazione parzialmente riuscita. Di seguito gli errori rimanenti:",
        "import_spaces": "Importa pertinenze",
        "import_units": "Importa unità per",
        "lot": "lotto",
        "lots": "lotti",
        "no": "no",
        "noLevels": "Nessun {levels}",
        "phase": "fase",
        "phases": "fasi",
        "plot": "lotto",
        "select_level_above": "Selezioni un {level} per continuare",
        "start_upload": "Avvia caricamento",
        "step": "Passaggio",
        "unit_info": "Potrà importare le unità una volta creato il progetto",
        "unit_limit": "Sta cercando di importare più unità di quelle consentite. Rimuova {exceeded_by} unità oppure ci contatti per aumentare il numero di unità consentite",
        "units": "unità",
        "upload_filled_template": "Carica il modello compilato",
        "upload_new_file": "Carica nuovo file",
        "upload_spaces": "Carica pertinenze",
        "upload_units": "Carica unità",
        "uploaded_file": "File caricato",
        "validations_failed": "Alcune convalide non sono riuscite",
        "yes": "sì"
      },
      "labels": {
        "activate": "Attiva progetto",
        "checkLevels": "Selezioni i livelli che desidera aggiungere:",
        "companyInfo": "Informazioni organizzazione",
        "companyNameTitle": "Nome organizzazione",
        "congratulationsNewProject": "Complimenti per il Suo nuovo progetto",
        "copyFromTemplate": "Copia dal progetto modello (facoltativo)",
        "customer_can_create_issue": "Il cliente può creare una segnalazione",
        "customersCanLogIn": "I clienti di questo progetto possono accedere con",
        "deactivate": "Disattiva progetto",
        "deactivated": "Disattivato",
        "deactivatedProjects": "Progetti disattivati",
        "download_export": "Scarica la mia esportazione",
        "downloading_export": "Scaricamento",
        "endsOn": "Termina il {enddate}",
        "export_expiration": "I dati della Sua esportazione sono pronti per essere scaricati. Rimarranno disponibili fino al {time}",
        "export_explanation": "Richieda un'esportazione di tutti i Suoi dati, comprese le conversazioni e i documenti.",
        "export_failed": "Esportazione non riuscita",
        "export_file": "Esporta il mio file",
        "export_notification_snack": "La raccolta del file può richiedere alcuni minuti. Riceverà una notifica quando sarà pronto per essere scaricato.",
        "export_prepared": "I dati della Sua esportazione saranno pronti a breve per essere scaricati.",
        "export_preparing": "Preparazione dell'esportazione",
        "filterProject": "Selezioni un progetto",
        "finalSteps": "Passaggi finali",
        "follow": "Segua {project} per ricevere le notifiche.",
        "followedProjects": "I miei progetti",
        "following": "Seguito",
        "general": "Generale",
        "importContacts": "Sì, desidero importare i contatti dei clienti",
        "importInformationSubtitle": "Invece di aggiungere pertinenze e contatti uno per uno, possiamo aiutarla a importare un file CSV. Selezioni le caselle sottostanti e un membro del team Ziggu la contatterà.",
        "importInformationTitle": "Importare informazioni?",
        "importSpaces": "Sì, desidero importare le pertinenze di parcheggio e deposito",
        "importUnits": "Sì, desidero importare le unità e le loro informazioni",
        "included": "Incluso",
        "internal": "Interno",
        "invoice_subtitle": "Invieremo una fattura solo se necessario, ad esempio quando non ha più unità disponibili nel Suo pacchetto.",
        "invoice_title": "A quale indirizzo email possiamo inviare le nostre fatture?",
        "isTemplateProject": "Questo è un progetto modello",
        "levelBuildingExplainer": "Selezioni questa opzione se ha più unità all'interno di uno o più edifici.",
        "levelPhaseExplainer": "Selezioni questa opzione se il Suo progetto è costruito in fasi diverse, distribuite nel tempo.",
        "levelPlotExplainer": "Selezioni questa opzione se il Suo progetto è composto da più particelle di terreno.",
        "levelProjectExplainer": "Il progetto è il blocco costruttivo più grande ed è essenziale per iniziare.",
        "levelUnitExplainer": "L'unità è il blocco costruttivo più piccolo. È la casa o l'appartamento che sta costruendo per i Suoi clienti.",
        "levels": "Struttura del progetto",
        "limitReached": "Limite di progetti raggiunto",
        "nameTitle": "Qual è il nome del progetto?",
        "newProjectTitle": "Creiamo il Suo nuovo progetto!",
        "noAccess": "Non ha accesso a questo progetto",
        "noFollowedProjects": "Faccia clic sull'icona delle notifiche per seguire un progetto.",
        "noProjects": "Nessun progetto trovato",
        "optional_information": "Informazioni facoltative",
        "optional_information_subtitle": "C'è qualcos'altro che desidera condividere con noi?",
        "otherProjects": "Altri progetti",
        "outOfProjects": "Sembra che il Suo pacchetto abbia esaurito i progetti attivi.",
        "outOfProjectsContact": "Contatti Ziggu per aumentare il Suo pacchetto e continuare a creare progetti.",
        "partner_invitation_notice": "{partner} non è ancora stato invitato. Un invito verrà inviato quando {partner} verrà aggiunto ai partner del progetto.",
        "pendingProjects": "{first_project_name} è stato richiesto ed è attualmente in fase di configurazione da parte di Ziggu | {count} progetti sono stati richiesti e sono attualmente in fase di configurazione da parte di Ziggu",
        "permission_partner_project": "Un partner con cui condividere facilmente documenti e proposte",
        "permissionsOwnerOnly": "Solo i membri del team con ruolo Proprietario possono aggiungere nuovi gestori di progetto",
        "permissionsRoleMaintainer": "Un membro del team con accesso a questo progetto",
        "project": "Progetto {project}",
        "projectBranding": "Branding del progetto",
        "projectIsDeactivated": "Questo progetto è disattivato",
        "projectMaintainers": "Gestori di progetto",
        "projectName": "Nome del progetto",
        "projectStructure": "Struttura del progetto",
        "projectStructureSubtitle": "Ora ha la possibilità di aggiungere 3 livelli aggiuntivi per organizzare meglio le Sue unità.</br>Li esamineremo insieme, passaggio dopo passaggio.",
        "projectStructureSubtitleOld": "La struttura del progetto viene definita una sola volta all'inizio del progetto",
        "project_label": "Progetto",
        "project_partners": "Partner del progetto",
        "projects": "Progetti",
        "remove_project_partner_prohibited": "{partner} è stato aggiunto alle decisioni di questo progetto e non può essere rimosso dai partner del progetto.",
        "remove_project_partner_prohibited_label": "Impossibile rimuovere il partner del progetto",
        "searchProject": "Cerca progetto",
        "searchProjects": "Cerca progetto",
        "selectATemplateProject": "Selezioni un progetto modello",
        "selected": "Selezionato",
        "showProject": "Mostra progetto",
        "spaces": "Pertinenze",
        "startsOn": "Inizia il {startdate}",
        "step1Info": "Esaminiamo alcuni dettagli per iniziare.",
        "step1Title": "Complimenti per il Suo nuovo progetto",
        "step2Info": "A quale organizzazione possiamo indirizzare la fattura?",
        "step2Title": "Dettagli di fatturazione",
        "step3Title": "Livelli intermedi necessari?",
        "step4Info": "Cosa succede adesso? Ziggu configurerà {project} entro 3-5 giorni lavorativi. Riceverà una notifica non appena tutto sarà pronto.",
        "templateProjects": "Progetti modello",
        "unFollow": "Non riceverà più notifiche per {project}.",
        "underConstruction": "In costruzione",
        "units": "Unità",
        "unitsCountSubtitle": "Quante unità?",
        "unselected": "Faccia clic per selezionare",
        "youAreEditingTemplateProject": "Sta modificando un progetto modello",
        "you_have_inbound_emails": "Ha 1 email in arrivo non elaborata | Ha {number} email in arrivo non elaborate"
      },
      "messages": {
        "units_count_max": "Se desidera creare più unità, ci contatti tramite il pulsante della chat."
      },
      "modals": {
        "add_project": {
          "step_1": {
            "title": "Configuriamo il Suo nuovo progetto"
          },
          "step_3": {
            "subtitle": "Faccia clic sulle schede per attivare i livelli intermedi.",
            "title": "Servono livelli intermedi?"
          },
          "step_4": {
            "info": "I modelli di decisioni e questionari possono essere importati una volta create le unità per questo progetto.",
            "placeholder": "Selezioni un progetto o lasci vuoto questo campo se non desidera copiare da un modello",
            "title": "Utilizzare un modello come base?"
          }
        }
      },
      "navigation": {
        "backToProjects": "Torna ai progetti"
      },
      "notifications": {
        "emailHasBeenCopied": "Indirizzo email copiato",
        "pictureChangedSuccessfully": "L'immagine è stata aggiornata. Le modifiche potrebbero richiedere fino a un'ora per essere visibili.",
        "tokenCopied": "Token copiato con successo",
        "urlHasBeenCopied": "URL copiato con successo"
      },
      "placeholders": {
        "employees": {
          "none": {
            "subtitle": "Non ha accesso ad alcun progetto. Chieda a un membro del team con ruolo Proprietario di concederle l'accesso.",
            "title": "Nessun progetto"
          }
        },
        "partners": {
          "noProjectSubtitle": "Riceverà una notifica quando le verrà assegnato un nuovo progetto",
          "noProjectTitle": "Nessun progetto ancora"
        }
      },
      "snackbars": {
        "duplicate": "Il processo di copia è iniziato e potrebbe richiedere alcuni istanti. Aggiorni la pagina dopo un paio di minuti."
      },
      "sort": {
        "nameAsc": "Nome A → Z",
        "nameDesc": "Nome Z → A",
        "newest": "Più recenti",
        "oldest": "Meno recenti"
      },
      "toasts": {
        "activateSuccess": "{project_name} è stato attivato con successo.",
        "deactivateSuccess": "{project_name} è stato disattivato con successo.",
        "duplicate": "Il progetto è stato creato, ma la copia del modello potrebbe richiedere alcuni minuti."
      },
      "tooltip": {
        "hasNoActiveUnits": "Non ha unità attive",
        "turnOffNotifications": "Disattiva notifiche per {project}",
        "turnOnNotifications": "Attiva notifiche per {project}"
      },
      "validation": {
        "addressInformationRequired": "Informazioni sull'indirizzo richieste",
        "companyNeedName": "Il nome dell'organizzazione è obbligatorio",
        "companyNeedVatNumber": "La partita IVA è obbligatoria",
        "dateAfter": "La data deve essere successiva alla data di inizio",
        "lessThanOrEqual": "Il numero deve essere minore o uguale a {max_number}",
        "maxLength": "Il nome può contenere al massimo {length} caratteri",
        "nameAlreadyTaken": "Il nome è già utilizzato per questo progetto",
        "needName": "Titolo obbligatorio",
        "needNumber": "Deve essere un numero (ad es. 850)",
        "needUnitsCount": "Il numero di unità è obbligatorio"
      }
    }
  }
}
